/**
 * localStorage helpers for the JWT + cached /me/ payload.
 *
 * Kept in one place so logout, bootstrap, and both axios 401 handlers
 * wipe the same keys.  A leftover ``taskydo.user`` after a failed /me/
 * is what made LoginPage believe the session was still live and bounce
 * to /task.
 */
import { STORAGE_KEYS } from '../config';

let signedOut = false;

function storage() {
  if (typeof localStorage === 'undefined') return null;
  return localStorage;
}

/** True after Logout until a successful login writes new creds. */
export function isSignedOut() {
  return signedOut;
}

export function markSignedOut() {
  signedOut = true;
  clearLocalAuth();
}

export function markSignedIn() {
  signedOut = false;
}

export function clearLocalAuth() {
  const store = storage();
  if (!store) return;
  try {
    store.removeItem(STORAGE_KEYS.ACCESS);
    store.removeItem(STORAGE_KEYS.REFRESH);
    store.removeItem(STORAGE_KEYS.USER);
  } catch {
    // Safari private mode / quota — ignore, in-memory state still clears.
  }
}

export function readStoredUser() {
  const store = storage();
  if (!store) return null;
  try {
    const raw = store.getItem(STORAGE_KEYS.USER);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function writeStoredUser(user) {
  if (signedOut && user) return;
  const store = storage();
  if (!store) return;
  try {
    if (!user) {
      store.removeItem(STORAGE_KEYS.USER);
      return;
    }
    store.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
  } catch {
    // ignore
  }
}

export function writeTokens({ access, refresh } = {}) {
  if (signedOut) return;
  const store = storage();
  if (!store) return;
  try {
    if (access) store.setItem(STORAGE_KEYS.ACCESS, access);
    if (refresh) store.setItem(STORAGE_KEYS.REFRESH, refresh);
  } catch {
    // ignore
  }
}

export function readRefreshToken() {
  const store = storage();
  if (!store) return null;
  try {
    return store.getItem(STORAGE_KEYS.REFRESH);
  } catch {
    return null;
  }
}
